export default "__VITE_PUBLIC_ASSET__97a48cf8__"